(()=>{
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  const seen=new WeakSet();
  function init(root=document){
    if(reduced.matches)return;
    const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
      if(!entry.isIntersecting)return;
      const heading=entry.target.querySelector('h2');
      if(heading){
        const walker=document.createTreeWalker(heading,NodeFilter.SHOW_TEXT),nodes=[];
        while(walker.nextNode())nodes.push(walker.currentNode);
        let index=0;
        nodes.forEach(node=>{
          const fragment=document.createDocumentFragment();
          node.textContent.split(/(\s+)/).forEach(word=>{
            if(!word.trim()){fragment.append(document.createTextNode(word));return;}
            const span=document.createElement('span');span.textContent=word;span.className='hx-reveal-word';fragment.append(span);
            span.animate([{opacity:.15,filter:'blur(2px)'},{opacity:1,filter:'blur(0)'}],{duration:650,delay:index++*38,fill:'backwards',easing:'ease-out'});
          });node.replaceWith(fragment);
        });
      }
      entry.target.animate([{opacity:.45,transform:'translateY(18px)'},{opacity:1,transform:'translateY(0)'}],{duration:850,easing:'cubic-bezier(.2,.7,.2,1)'});
      observer.unobserve(entry.target);
    }),{threshold:.15});
    root.querySelectorAll('[data-hx-reveal]').forEach(el=>{if(!seen.has(el)){seen.add(el);observer.observe(el);}});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();

